import { useState, useEffect, useRef } from 'react';

/**
 * Custom hook to manage change-default-song flow logic
 */
export const useChangeDefaultSong = ({
  isChangeDefaultSongFlow,
  subscriberGallery,
  songs,
  contentRef,
}) => {
  const [selectedSongId, setSelectedSongId] = useState(null);
  const [isButtonSticky, setIsButtonSticky] = useState(false);

  // Check if button should be sticky based on content overflow
  const checkIfButtonShouldBeSticky = () => {
    if (contentRef.current && isChangeDefaultSongFlow && songs.length > 0) {
      const content = contentRef.current;
      const isOverflowing = content.scrollHeight > content.clientHeight;
      setIsButtonSticky(isOverflowing);
    }
  };

  // Monitor overflow for sticky button
  useEffect(() => {
    checkIfButtonShouldBeSticky();
    const handleResize = () => checkIfButtonShouldBeSticky();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [songs, isChangeDefaultSongFlow]);

  // Set default selected song when entering flow
  useEffect(() => {
    if (isChangeDefaultSongFlow && subscriberGallery?.length > 0) {
      const defaultSong = subscriberGallery.find((song) => song.isDefault === true);
      if (defaultSong) {
        setSelectedSongId(defaultSong.productId || defaultSong.id);
      }
    }
  }, [isChangeDefaultSongFlow, subscriberGallery]);

  return { selectedSongId, setSelectedSongId, isButtonSticky };
};
